export function splitImage(imageFile) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onload = function (e) {
        const img = new Image();
        img.src = e.target.result;
  
        img.onload = function () {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const splitPosition = Math.floor(img.width / 2);
  
          canvas.width = splitPosition;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0, splitPosition, img.height, 0, 0, splitPosition, img.height);
          canvas.toBlob(function (blobLeft) {
            const leftFile = new File([blobLeft], 'left.jpg', { type: 'image/jpeg' });
  
            canvas.width = img.width - splitPosition;
            canvas.height = img.height;
            ctx.drawImage(img, splitPosition, 0, img.width - splitPosition, img.height, 0, 0, img.width - splitPosition, img.height);
            canvas.toBlob(function (blobRight) {
              const rightFile = new File([blobRight], 'right.jpg', { type: 'image/jpeg' });
              resolve([leftFile, rightFile]);
            }, 'image/jpeg');
          }, 'image/jpeg');
        };
      };
  
      reader.readAsDataURL(imageFile);
    });
  }
  